import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    defaultGridElementResource,
    GridElementMutationResourceSchema,
    useGridElementActions,
} from '../../../../resource/resources/artifacts/use_case/representation/gridElementResource';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../util/useSelectorFunctions';
import { GridElementContent } from './GridElementContent';

export const GridElementEditDialog = ({
    onClose,
    objectId,
    versionedInId,
    projectId,
    onSuccess,
}: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
    projectId: string | undefined | null;
    onSuccess?: () => void;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const gridElementActions = useGridElementActions();
    const gridElementQuery = gridElementActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionedInId);
    const updateGridElement = gridElementActions.useUpdateResource();
    const validation = gridElementActions.useValidateResource(gridElementQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: GridElementMutationResourceSchema,
        defaultValues: defaultGridElementResource,
        submitHandler: async (data) => {
            await updateGridElement.mutateAsync(
                {
                    resource: data,
                    id: data.id,
                },
                {
                    onSuccess: onSuccess,
                }
            );
        },
        reactiveValues: gridElementQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Grid Element'}
            resourceType={ResourceType.GRID_ELEMENT}
            resourceValidationResult={validation.data}
            metaDataInfo={gridElementQuery.data}
        >
            <QueryBaseComponent name="Grid Element" query={gridElementQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <GridElementContent
                        projectId={projectId}
                        projectVersionId={versionedInId}
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={gridElementQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
